import { usePocQuery } from 'core/custom-hooks/use-poc-query.hook';
import { settingsKeys } from 'core/query-client/keys/settings.keys';
import { updateQuery } from 'core/query-client/query-client';
import { executeRequest } from 'core/utils/backend-service';
import { getDeviceConfigurationEAPSettingsList } from 'modules/settings/pods/settings-devices/settings-devices-eap-settings/service/eap-settings.service';
import { EapSettings } from 'modules/settings/pods/settings-devices/settings-devices-menu.model';
import { PropsWithChildren, useMemo, useState } from 'react';
import { EapSettingsListContext } from '../eap-settings-list.context';

export const EapSettingsListProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const [selectedRows, setSelectedRows] = useState<EapSettings[]>([]);

    const { data: configurations = [], isFetching: isLoading } = usePocQuery<EapSettings[]>({
        queryKey: settingsKeys.eapList(),
        queryFn: () => executeRequest(() => getDeviceConfigurationEAPSettingsList()),
    });

    const value = useMemo(
        () => ({
            configurations,
            isLoading,
            selectedRows,
            refreshList: () => updateQuery(settingsKeys.eapList()),
            setSelectedRows,
        }),
        [configurations, isLoading, selectedRows]
    );

    return <EapSettingsListContext.Provider value={value}>{children}</EapSettingsListContext.Provider>;
};
